import Vue from 'vue';
import Bugsnag from "@bugsnag/js";

// Reaktív, app-szintű állapot
export const networkState = Vue.observable({
    online: navigator.onLine,     // kezdeti érték
    lastChangeAt: new Date(),     // utolsó váltás ideje
});

// Egyszerű logger (cseréld toast-ra/telemetry-re ha kell)
function log(status) {
    //const ts = new Date().toISOString();
    // Itt teheted be: console.log helyett pl. Sentry/Analytics/Toast
    if (!status) {
        localStorage.setItem("offline", JSON.stringify(networkState));
    } else {
        if (localStorage.getItem("offline")) {
            let helper = JSON.parse(localStorage.getItem("offline"));
            Bugsnag.notify("Network change", function (event) {
                event.severity = "error";
                event.context = `Network changed: OFFLINE - ${helper.lastChangeAt}`
            });
            localStorage.removeItem("offline");
        }
        Bugsnag.notify("Network change", function (event) {
            event.severity = "info";
            event.context = `Network changed: ${status ? 'ONLINE' : 'OFFLINE'}`
        });
    }
}

function updateOnline(value) {
    if (networkState.online !== value) {
        networkState.online = value;
        networkState.lastChangeAt = new Date();
        log(value);
        // Események komponenseknek
        window.dispatchEvent(new CustomEvent(value ? 'app:online' : 'app:offline'));
    }
}

// Böngésző események
window.addEventListener('online', () => updateOnline(true));
window.addEventListener('offline', () => updateOnline(false));

// Opcionális: flapping (gyors ki/be) ellen kis késleltetés, ha szeretnéd:
// let timer;
// window.addEventListener('online', () => {
//   clearTimeout(timer);
//   timer = setTimeout(() => updateOnline(true), 1000);
// });
// window.addEventListener('offline', () => {
//   clearTimeout(timer);
//   timer = setTimeout(() => updateOnline(false), 500);
// });

export default {
    install(Vue) {
        // $network minden komponensben
        Object.defineProperty(Vue.prototype, '$network', {
            get() { return networkState; }
        });
    }
};
